var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosTruckTraxWebVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 190.2 80.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#008ef3}")), /*#__PURE__*/React.createElement("g", {
    id: "Login-_x2B_-Landing-Screens"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ScaleTrax-_x2014_-Login-_x2B_-Landing-Screens-_x2014_-01A-Default-Login-Screen-",
    transform: "translate(-620 -348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window",
    transform: "translate(-211 -91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login-Panel",
    transform: "translate(784 434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-Logo",
    transform: "translate(81 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Name",
    transform: "translate(0 61.5)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Web",
    d: "M145.8-26v4.8c1-.8 2.4-1.2 3.8-1.2 4.5 0 6.6 3.8 6.6 7.5 0 5.3-3.5 7.5-8.1 7.5-2.5 0-4.6-.5-6.7-1.3V-26zm-39.6 4 3 7.7 3-7.7h2.9l3.1 7.7 2.9-7.7h4.5l-5.8 14.6h-2.6l-3.5-8.6-3.5 8.6h-2.6l-6-14.6zm27.1-.4c3.7 0 6.8 2.5 6.8 7.6v.8h-10c.3 2.1 2 3.4 4.2 3.4 1.8 0 3.7-.6 5.4-1.5V-9c-1.8 1-3.8 1.6-6.3 1.6-4.7 0-7.8-3-7.8-7.6 0-4.4 2.9-7.4 7.7-7.4m15.2 3.4c-.8 0-1.8.4-2.7 1.1v6.8c.6.2 1.6.4 2.3.4 1.5 0 3.5-.8 3.5-4.1 0-2.6-1.3-4.2-3.1-4.2m-15.5-.4c-1.7 0-3 1.3-3 3.2h5.9c0-2-1.1-3.2-2.9-3.2",
    className: "st0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trucktrax",
    d: "M.5-22v7.7c0 2.3 1.3 3.4 3 3.4s2.8-1 2.8-3.3V-22h4.2v8.2c0 4.2-2.3 6.6-7.1 6.6-4.5 0-7.1-2.3-7.1-6.5V-22zm19.4-.2c1.9 0 3.7.4 5.5 1.3v3.9c-1.6-1.1-3.5-1.6-5-1.6-3 0-4.3 2-4.3 4 0 2.6 2 3.9 4.3 3.9 1.2 0 3.3-.6 5.1-1.7v3.9c-1.7 1-3.4 1.4-5.5 1.4-5.3 0-8.3-3.2-8.3-7.5 0-4 2.9-7.6 8.2-7.6m-31.2.2c3.8 0 6 1.4 6 4.4 0 1.7-.9 3.1-2.2 3.8.8.5 1.5 1.8 2 3l1.6 3.5h-4.5l-1.3-3.2c-.7-1.6-1.2-2.2-2.2-2.2h-1.3v5.4h-4.2V-22zM57-25.9v3.9h-5.9v14.7h-4.8V-22h-5.8v-3.9zM80.5-22l5.6 13 4.7-5.9-5.6-7.1h5.1l3.1 4.4 3.1-4.4h5.1L96-15l6.2 7.6H97l-3.6-5-3.6 5h-7.7l-1-2.4h-5.5l-.8 2.4H66l-1.3-3.2c-.7-1.6-1.2-2.2-2.2-2.2h-1.3v5.4H57V-22h6.1c3.8 0 6 1.4 6 4.4 0 1.7-.9 3.1-2.2 3.8.8.5 1.5 1.8 2 3l1.5 3.3L76.1-22zm-97.9-3.9v3.9h-5.9v14.7h-4.8V-22H-34v-3.9zM31.5-22v5.6l4.4-5.6h4.6l-5.2 6.7 6.7 8h-5.3l-5.2-6.1v6.1h-4.2V-22zm46.6 4.6-1.6 4.9h3.6zM-12-19h-1.2v3.6h1.2c1.4 0 2.4-.5 2.4-1.8Q-9.75-19-12-19m74.5 0h-1.2v3.6h1.2c1.4 0 2.4-.5 2.4-1.8q-.15-1.8-2.4-1.8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#151f28"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    d: "M84.4 10h-9.1v-20.5c0-1.3-1-2.3-2.3-2.3H61c-1.3 0-2.3 1-2.3 2.3V9.6h-7.3v-20.5c0-1.3-1-2.3-2.3-2.3H40v-6.4h30c.8 1.1 2 1.7 3.3 1.7 2.2 0 4-1.8 4-4s-1.8-4-4-4c-1.3 0-2.6.6-3.3 1.7H37.5c-1.3 0-2.3 1-2.3 2.3v11.1c0 1.3 1 2.3 2.3 2.3h9.1V12c0 1.3 1 2.3 2.3 2.3h12c1.3 0 2.3-1 2.3-2.3V-8.2h7.3v20.5c0 1.3 1 2.3 2.3 2.3H82V21H52.3c-.8-1.1-2-1.7-3.3-1.7-2.2 0-4 1.8-4 4s1.8 4 4 4c1.3 0 2.6-.6 3.3-1.7h32.1c1.3 0 2.3-1 2.3-2.3v-11c0-1.3-1.1-2.3-2.3-2.3",
    className: "st0"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTruckTraxWebVertical);
export default __webpack_public_path__ + "static/media/logos-truck-trax-web-vertical.954a9fdbbc3c28539f19df8192c570c5.svg";
export { ForwardRef as ReactComponent };